// Interruptor manual de la decoración temática del sitio.
// Valores posibles: 'mundial' | 'navidad' | 'none'
//
// Cambiá esta única línea para prender/apagar o cambiar la decoración.
// (Por ahora solo está implementado 'mundial'; el resto quedan reservados.)
export const DECORACION = 'mundial';

// Cada cuánto el hincha festeja el gol (con confetti), en milisegundos.
// 120000 = 2 minutos. Subilo/bajalo a gusto.
export const CONFETTI_LOGO_INTERVAL_MS = 120000;
